import * as actions from '../actions/actions'

const initialState = {
    bankId: ''
}

export default function authNavbar(state = initialState, action) {
    switch (action.type) {
        case actions.AUTH_NAVBAR_BANK_ID:
            return authNavbarBankId(state, action)
        default:
            return state
    }
}

const authNavbarBankId = (state, action) => {
    return {
        ...state,
        bankId: action.value
    }
}